import { FC } from "react";
import { useTranslation } from "react-i18next";
import Breadcrumbs from "@dashboard/components/breadcrumbs/breadcrumbs";
import { UiButton } from "@domun/component-library";
import { DeliveryPageWrapper } from "../../components/delivery-page-layout/delivery-page-layout.styled";
import { useDeliveryCoverage } from "../../hooks/use-delivery-coverage.hook";

const DeliveryCoverage: FC = () => {
  const { t } = useTranslation();
  const {
    view,
    setView,
    localEnabled,
    nationalEnabled,
    cities,
    cityInput,
    setCityInput,
    loading,
    addCity,
    removeCity,
    handleLocalToggle,
    handleNationalToggle,
    handleSave,
    openPreview,
    breadcrumbs,
    filteredCities,
  } = useDeliveryCoverage();

  if (view === "select") {
    return (
      <DeliveryPageWrapper>
        <div className="header">
          <Breadcrumbs items={breadcrumbs} backButton />
        </div>
        <h3>{t("delivery.coverage.title")}</h3>
        <p>{t("delivery.coverage.selectType")}</p>
        <div className="actions">
          <UiButton onClick={() => setView("local")}>
            {t("delivery.coverage.local")}
          </UiButton>
          <UiButton onClick={() => setView("national")}>
            {t("delivery.coverage.national")}
          </UiButton>
        </div>
        <button type="button" className="link-button" onClick={openPreview}>
          {t("delivery.coverage.previewStore")}
        </button>
      </DeliveryPageWrapper>
    );
  }

  return (
    <DeliveryPageWrapper>
      <div className="header">
        <Breadcrumbs items={breadcrumbs} backButton />
      </div>
      <button type="button" className="link-button" onClick={() => setView("select")}>
        ← {t("back")}
      </button>
      <h2>
        {view === "local"
          ? t("delivery.coverage.local")
          : t("delivery.coverage.national")}
      </h2>

      {view === "local" && (
        <div className="card">
          <div className="toggle-row">
            <span>{t("delivery.coverage.localEnabled")}</span>
            <input
              type="checkbox"
              checked={localEnabled}
              onChange={(e) => handleLocalToggle(e.target.checked)}
            />
          </div>
          <h3>{t("delivery.coverage.cities")}</h3>
          <div className="field">
            <input
              type="text"
              list="city-suggestions"
              placeholder={t("delivery.coverage.cityPlaceholder")}
              value={cityInput}
              onChange={(e) => setCityInput(e.target.value)}
            />
            <datalist id="city-suggestions">
              {filteredCities.map((c) => (
                <option key={c} value={c} />
              ))}
            </datalist>
          </div>
          <UiButton onClick={addCity}>{t("delivery.coverage.addCity")}</UiButton>
          <ul>
            {cities.map((city) => (
              <li key={city}>
                {city}{" "}
                <button type="button" className="link-button" onClick={() => removeCity(city)}>
                  ×
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      {view === "national" && (
        <div className="card">
          <div className="toggle-row">
            <span>{t("delivery.coverage.nationalEnabled")}</span>
            <input
              type="checkbox"
              checked={nationalEnabled}
              onChange={(e) => handleNationalToggle(e.target.checked)}
            />
          </div>
        </div>
      )}

      <div className="actions">
        <UiButton
          onClick={handleSave}
          isLoading={loading}
          disabled={loading}
        >
          {t("delivery.coverage.save")}
        </UiButton>
        <button type="button" className="link-button" onClick={openPreview}>
          {t("delivery.coverage.previewStore")}
        </button>
      </div>
    </DeliveryPageWrapper>
  );
};

export default DeliveryCoverage;
